export const CONTENT_GROUP = {
  DRAFTS: 'Drafts',
  EVENTGROUPS: 'Eventgroups',
  HOMEPAGE: 'Homepage',
  PERFORMANCES: 'Performances',
}



/** WEBPACK FOOTER **
 ** ./src/constants/analytics-constants.js
 **/